import { IMyAccountSections } from './types';
interface WidgetInterface {
  [key: string]: IMyAccountSections;
}

export const loadWidgets = (
  localWidgets: WidgetInterface,
  remoteWidgets: WidgetInterface,
  object: IMyAccountSections
) => {
  let modifiedWidget = object;
  if (object.children) {
    modifiedWidget.children = object.children
      .map((child) => {
        let currObj;
        //if a new widget is present in remote, then we return the object with updated values through destructuring
        if (remoteWidgets[child]) {
          currObj = { ...localWidgets[child], ...remoteWidgets[child] };
        } else {
          currObj = { ...localWidgets[child] };
        }
        if (currObj.children?.length) {
          return loadWidgets(localWidgets, remoteWidgets, currObj);
        }

        return currObj;
      })
      .filter((child) => child.isEnabled);
  }
  return modifiedWidget;
};
